export enum SystemMessageSeverity {
  Info = "info",
  Warning = "warning",
  Alert = "alert",
}

const systemMessageSeverityValues = Object.values(SystemMessageSeverity);

export function isSystemMessageSeverity(value: unknown): value is SystemMessageSeverity {
  return parseSystemMessageSeverity(value) !== undefined;
}

export function parseSystemMessageSeverity(value: unknown): SystemMessageSeverity | undefined {
  if (typeof value === "string") {
    return systemMessageSeverityValues.find((severity) => severity === value.toLowerCase());
  }

  if (typeof value === "number" && Number.isInteger(value)) {
    return systemMessageSeverityValues[value];
  }

  return undefined;
}
